(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('homepage-infinite-scroll')) return;

    class HomepageInfiniteScroll extends HTMLElement {
      constructor() {
        super();

        this.loading = false;
        this.page = Number(this.dataset.currentPage || 1);
        this.totalPages = Number(this.dataset.totalPages || 1);
        this.pageSize = Number(this.dataset.pageSize || 0);
        this.sectionId = this.dataset.sectionId;
        this.statusText = this.querySelector('.homepage-infinite-scroll__text');
        this.spinner = this.querySelector('.homepage-infinite-scroll__spinner');
        this.debugCount = this.querySelector('.homepage-infinite-scroll__debug-count');
        this.debugError = this.querySelector('.homepage-infinite-scroll__debug-error');

        // TEMP DEBUG: loaded count starts from the products already
        // rendered server-side on page 1 (currentPage * pageSize is an
        // upper-bound estimate; the collection's last page may render fewer).
        this.loadedCount = this.page * this.pageSize;
        this.updateDebug();

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.loadNextPage();
            }
          },
          {
            root: null,
            rootMargin: '800px 0px',
            threshold: 0
          }
        );

        this.observer.observe(this);

    
        this.addEventListener('homepage-infinite-scroll:check', () => {
          this.checkAndLoad();
        });

        requestAnimationFrame(() => this.checkAndLoad());
      }

      isNearViewport() {
        // Kept in sync with the observer's rootMargin above.
        const margin = 800;
        const rect = this.getBoundingClientRect();
        return rect.top <= window.innerHeight + margin && rect.bottom >= -margin;
      }

      checkAndLoad() {
        if (!this.loading && this.page < this.totalPages && this.isNearViewport()) {
          this.loadNextPage();
        }
      }

      async loadNextPage() {
        if (this.loading || this.page >= this.totalPages) {
          if (this.page >= this.totalPages) this.finish();
          return;
        }

        this.loading = true;
        this.classList.add('is-loading');

        const nextPage = this.page + 1;
        this.setStatus('Loading more products...', true);

        try {
          const url = new URL(window.location.href);
          url.searchParams.set('page', nextPage);

          const response = await fetch(url.toString(), {
            method: 'GET',
            headers: {
              Accept: 'text/html'
            },
            credentials: 'same-origin'
          });

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');

          const section = doc.querySelector(
            `[data-testid="product-list"][data-infinite-scroll-section="${CSS.escape(this.sectionId)}"]`
          );

          if (!section) {
            throw new Error('Homepage product-list section was not found in the response.');
          }

          const incomingGrid = section.querySelector('[data-testid="resource-list-grid"]');
          const currentGrid = document.querySelector(
            `[data-testid="product-list"][data-infinite-scroll-section="${CSS.escape(this.sectionId)}"] [data-testid="resource-list-grid"]`
          );

          if (!incomingGrid || !currentGrid) {
            throw new Error('Product grid was not found.');
          }

          const incomingItems = Array.from(incomingGrid.children);

          if (!incomingItems.length) {
            this.finish();
            return;
          }

          // PERFORMANCE NOTE: if product cards render <img> tags without
          // loading="lazy" decoding="async", add them in the product-card
          // partial - that's a second easy win alongside content-visibility,
          // but it lives outside this file so isn't touched here.
          currentGrid.append(...incomingItems.map((item) => item.cloneNode(true)));

          // TEMP DEBUG: track real count of product cards now in the DOM.
          this.loadedCount = currentGrid.children.length;
          this.debugErrorMessage = '';
          this.updateDebug();

          this.page = nextPage;
          this.dataset.currentPage = String(this.page);

          if (this.page >= this.totalPages) {
            this.finish();
          } else {
            this.setStatus('Loading more products...', true);
          }

          document.dispatchEvent(
            new CustomEvent('homepage:infinite-scroll:loaded', {
              detail: {
                sectionId: this.sectionId,
                page: this.page
              }
            })
          );
        } catch (error) {
          console.error('[Homepage Infinite Scroll]', error);
          this.setStatus('Unable to load more products. Please try again.', false);
          // TEMP DEBUG: show the real error text on-screen so it can be
          // read directly from a phone without needing DevTools/console access.
          this.debugErrorMessage = `Error on page ${nextPage}: ${error.message}`;
          this.updateDebug();
        } finally {
          this.loading = false;
          this.classList.remove('is-loading');

          // Critical for very fast scrolling:
          // after the request finishes, check again immediately. If the
          // sentinel is still within the preload area, fetch the next page
          // without requiring the user to scroll up/down first.
          requestAnimationFrame(() => this.checkAndLoad());
        }
      }

      setStatus(message, showSpinner) {
        if (this.statusText) this.statusText.textContent = message;
        if (this.spinner) this.spinner.hidden = !showSpinner;
      }

      // TEMP DEBUG: writes loaded-product count and last error (if any)
      // into the visible debug line below the spinner. Remove this method
      // and its call sites once the stuck-scroll issue is confirmed fixed.
      updateDebug() {
        if (this.debugCount) {
          this.debugCount.textContent = `Loaded: ${this.loadedCount} products · page ${this.page}/${this.totalPages}`;
        }
        if (this.debugError) {
          this.debugError.textContent = this.debugErrorMessage || '';
        }
      }

      finish() {
        if (this.observer) this.observer.disconnect();
        this.classList.add('is-finished');
        this.setStatus(this.dataset.endText || 'You reached the end.', false);
        this.updateDebug();
      }
    }

    customElements.define('homepage-infinite-scroll', HomepageInfiniteScroll);
  })();

  } catch(e) { console.error(e); }
})();
})();
